//import { schema } from 'normalizr';
import React from "react";
import { Record, List } from "immutable";
import Globalize from "globalize";
import me from "models/me";
import moment from "moment";
import titleCase from "lib/title-case";
import truncate from "truncate";
import { decodeHtml } from "../../components/utils/utilities";

const defaults = {
    base: "",
    label: "",
    editable: false,
    reference: undefined,
    type: undefined,
    default_value: "",
    formatters: List,
    derived_from: List,
};

class ElementRecord extends Record(defaults) {
    constructor(args = {}) {
        super(
            Object.assign({}, args, {
                derived_from:
                    args.derived_from && args.derived_from.map
                        ? List(args.derived_from.map((val) => new ElementRecord(val)))
                        : List(),
            })
        );
    }
    convertLegacyDateFormat(legacyFormat) {
        return legacyFormat
            .replace("%mon", "MMM")
            .replace("%mm", "M")
            .replace("%0mm", "MM")
            .replace("%dd", "D")
            .replace("%0dd", "DD")
            .replace("%yyyy", "YYYY");
    }

    formatValue(value, formatter) {
        switch (formatter.formatter) {
            case "money":
                const numericValue = Number(value);
                if (!Number.isNaN(numericValue)) {
                    value = Globalize.formatCurrency(numericValue, me._activeCurrency);
                }
                break;
            case "date":
                if (formatter.params && formatter.params.length) {
                    const format = this.convertLegacyDateFormat(formatter.params[0]);
                    value = moment.utc(value).format(format);
                }
                break;
            case "uppercase":
                value = value.toString().toUpperCase();
                break;
            case "lowercase":
                value = value.toString().toLowerCase();
                break;
            case "sentence_case":
                // eslint-disable-next-line no-useless-escape
                value = value
                    .toString()
                    .toLowerCase()
                    .replace(/(^\s*\w|[\.!\?]\s*\w)/g, function (c) {
                        return c.toUpperCase();
                    });
                break;
            case "capitalize_words":
                value = titleCase(value.toString());
                break;
            case "truncate":
                if (formatter.params && formatter.params.length) {
                    value = truncate(value.toString(), formatter.params[0]);
                }
                break;
            case "width":
                break;
            case "link":
                const link = value.toString().match(/^https?:\/\//i) ? value.toString() : `http://${value.toString()}`;
                // eslint-disable-next-line react/jsx-no-target-blank
                value = (
                    <a href={link} key={link} target="_blank">
                        {decodeHtml(value.toString())}
                    </a>
                );
                break;
            default:
                value = value.toString();
        }
        return value;
    }

    getValue(item, field) {
        let value;
        if (!field) {
            field = this;
        }
        if (field.type === "widget") {
            return ""; // Widgets are unsupported
        }
        if (field.derived_from.size) {
            value = field.derived_from.map((subfield) => {
                return subfield.getValue(item);
            });
        } else if (!field.reference) {
            value = field.default_value;
        } else {
            if (item.getIn) {
                // detect whether this is an ampersand model, will get rid of need for this later
                const reference = field.reference.split(".");
                value = item.getIn(reference) || field.default_value;
            } else {
                value = item.get(field.reference) || field.default_value;
            }
        }

        if (value && !Array.isArray(value)) {
            field.formatters.forEach((formatter) => {
                value = this.formatValue(value, formatter);
            });
        } else if (value && Array.isArray(value)) {
            value.forEach((val, index) => {
                if (val && !React.isValidElement(val)) {
                    field.formatters.forEach((formatter) => {
                        val = this.formatValue(val, formatter);
                        value[index] = val;
                    });
                }
            });
        }

        if (field.type === "view") {
            if (field.reference === "concatenate") {
                if (Array.isArray(value)) {
                    value = value.join("");
                }
            }
        }

        if (Array.isArray(value)) {
            // used for seasons, etc
            const isElement = value.some((entry) => React.isValidElement(entry));
            if (!isElement) {
                value = value.join(", ");
            }
        } else if (typeof value !== "string") {
            if (moment.isMoment(value)) {
                value = value.format("M/DD/YYYY");
            } else if (value instanceof Date) {
                value = moment(value).format("M/DD/YYYY");
            }
        }

        return value;
    }

    getWidth() {
        const field = this;
        let widthFormatter;
        if (field.type === "view" && field.derived_from.size) {
            const concatField = field.derived_from.find((entry) => entry.base === "item");
            widthFormatter =
                concatField && concatField.get("formatters").find((formatter) => formatter.formatter === "width");
        } else {
            widthFormatter = field.formatters.find((formatter) => formatter.formatter === "width");
        }
        return widthFormatter && widthFormatter.params && widthFormatter.params[0]
            ? Number(widthFormatter.params[0])
            : 0;
    }
}

export default ElementRecord;
